import gsap from 'gsap'
import AirDatepicker from 'air-datepicker'
import localeIt from 'air-datepicker/locale/it'
import localeEn from 'air-datepicker/locale/en'
import 'air-datepicker/air-datepicker.css'
import {winsize, riseAndFadeIn, riseAndFadeOut, validDigits, minicart, language, isAllMobileDevices, isMobile, headerClass,customDatalayerClass} from './bundle'
import {addToCart} from './CartFunctions'
import {SwiperProductFeed} from './SwiperSlideShow'
// let instance = null
class Product{
    constructor(container, awdScroll, data){
        this.data = data
        this.container = container
        this.awdScroll = awdScroll
        this.pageProduct = this.container.querySelector('.page-single-product')
        this.productType = this.pageProduct.getAttribute('data-product-type')
        this.openPopupAcquistaBtn = this.pageProduct.querySelector('.open-popup-acquista-btn')
        this.closePopupAcquistaBtn = this.pageProduct.querySelector('.buy-actions__close--btn')

        this.popupAcquista = this.container.querySelector('.popup-acquista')
        this.popupAcquistaBg = this.popupAcquista.querySelector('.popup-acquista__bg span')
        this.popupAcquistaContainer = this.container.querySelector('.popup-acquista__container')
        this.popupAcquistaWrapper = this.container.querySelector('.popup-acquista__wrapper')
        this.popupAcquistaInner = this.container.querySelector('.popup-acquista__inner')
        this.popupAsideBuyActions = this.container.querySelector('.buy-actions')
        this.popupAsideBuyActionsBg = this.container.querySelector('.buy-actions__bg span')
        this.popupAsideBuyActionsWrapper = this.container.querySelector('.buy-actions__center')

        this.disponibilita = this.pageProduct.getAttribute('data-product-disponibilita') || 99
        this.addToCartBtn = this.popupAcquista.querySelector('.add-to-cart-btn')

        //Confezioni
        if(this.popupAcquista.querySelector('.container-confezioni') !== null){
            this.containerConfezioni = this.popupAcquista.querySelector('.container-confezioni')
            this.containerConfezioniInner = this.containerConfezioni.querySelector('.confezioni')
            this.wrapperConfezioni = this.containerConfezioni.querySelector('.confezioni__wrapper')
            this.bgConfezioni = this.containerConfezioni.querySelector('.confezioni__bg')
            this.bgConfezioniSpan = this.containerConfezioni.querySelector('.confezioni__bg span')
            this.bgSiparioSpan = this.containerConfezioni.querySelector('.confezioni__sipario span')
            this.btnOpenContainerConfezioni = this.container.querySelector('.btn-open-container-confezioni')
            this.btnCloseContainerConfezioni = this.container.querySelector('.btn-close-container-confezioni')
            this.rowsConfezioniDesktop = this.popupAcquista.querySelectorAll('.row-confezione')
            
            this.bottoniAggiungiConfezione = this.containerConfezioni.querySelectorAll('.btn-add-confezione-to-cart')
            if(this.containerConfezioni.querySelector('.select-colori') !== null){
                this.selectsColoreConfezioni = this.containerConfezioni.querySelectorAll('.select-colori')
            }

            //Confezioni Mobile
            this.rowsConfezioniMobile = this.containerConfezioni.querySelectorAll('.row-confezione-mobile')

            this.isHoverConfezioniEnabled = false
        }

        if(this.container.querySelector('.aside-zoom') !== null){
            this.asideZoom = this.container.querySelector('.aside-zoom')
            this.asideImage = this.container.querySelector('.aside-zoom .image')
            this.asideImageInner = this.asideImage.querySelector('.img')
            this.imageScaled = this.popupAcquista.querySelector('.image-scaled')
            this.zoomBtn = this.container.querySelector('.zoom-btn')
            this.zoomBtnIcon = this.zoomBtn.querySelector('.zoom__icon')
            this.asideImageDimensions = this.asideImage.getBoundingClientRect()
            this.asideImageDimensionsHeight = this.asideImageDimensions.height
        }

        //Trigger features icons
        this.triggerFeaturesIcons = this.pageProduct.querySelector('.trigger-reveal-features-icons')
        this.productFeaturesLeft = this.pageProduct.querySelector('.product-features-left')
        this.productFeaturesRight = this.pageProduct.querySelector('.product-features-right')

        //Formato 
        if(this.productType === 'variable'){
            this.sizes = [...this.popupAcquista.querySelectorAll('.buy-actions__center .size')]
            this.sizes.forEach(size => {    
                if(size.classList.contains('selected') && size.getAttribute('data-size-disponibilita')){
                    this.disponibilita = size.getAttribute('data-size-disponibilita')
                }
            })
        }
        this.visiblePrice = this.popupAcquista.querySelector('.price-visible')
        this.visiblePriceSpan = this.visiblePrice.querySelector('.js-price-visible')
        if(this.visiblePrice.querySelector('.js-price-barrato') !== null){
            this.visiblePriceSpanBarrato = this.visiblePrice.querySelector('.js-price-barrato')
        }
        if(this.popupAcquista.querySelector('.price-hidden') !== null){
            this.hiddenPrice = this.popupAcquista.querySelector('.price-hidden')
            this.hiddenPriceSpan = this.hiddenPrice.querySelector('.js-price-hidden')
            if(this.hiddenPrice.querySelector('.js-price-barrato') !== null){
                this.hiddenPriceSpanBarrato = this.hiddenPrice.querySelector('.js-price-barrato')
            }
        }


        //Quantity
        this.quantitaSelezionata = 1
        this.inputQty = this.popupAcquista.querySelector('.input-qty')
        this.addQtyBtn = this.popupAcquista.querySelector('.qty__action--add')
        this.removeQtyBtn = this.popupAcquista.querySelector('.qty__action--remove')

        //FeedVino
        // console.log(this.container)
        // this.headerFeedVino = document.querySelector('.header-feed-vino')
        // this.headerFeedVinoHeight = this.headerFeedVino.getBoundingClientRect().height
        // this.headerFeedVinoWrapper = this.headerFeedVino.querySelector('.header-feed-vino__wrapper')

        //External
        this.header = document.querySelector('header')
        this.iconaBagQty = document.querySelector('.js-bag-counter')

        //Bool
        this.isAnimating = false
        this.isZoomEnabled = false
        this.isTouchDevice = isAllMobileDevices ? true : false


        this.initEvents()

        // console.log(this.container.querySelector('.orario'))
        // if(this.container.querySelector('.orario') !== null){
        //     console.log('orario exists')
        //     this.container.querySelectorAll('.orario').forEach(timeSlot => {
        //         timeSlot.addEventListener('click', () => {
        //             if(timeSlot.classList.contains('active')) return
        //             let f = timeSlot.getAttribute('data-from')
        //             let pd = timeSlot.getAttribute('data-posti-disponibili')
        //             this.disponibilita = pd
        //             let sh = timeSlot.getAttribute('data-orario')      
    
        //             this.container.querySelectorAll('.orario').forEach(o => {
        //                 o.classList.remove('active')
        //             })
        //             timeSlot.classList.add('active') 
        //             // this.resetInputQty()                        
        //             //Popolo l'add to cart button
        //             // this.updateAddToCartButton(f, pd, sh) 
        //         })
        //     })
        // }
    }

    initEvents(){
        //Se il link è diretto o se provengo dalla pagina Shop Wall allora inizializzo subito l'aperura del feed. 
        //Altrimenti l'apertura è gestita nel file bundle.js dopo il resolve della funzione pageTransitionBeforeEnter()
        // console.log(this.data)
        if(this.data){
            if(this.data.current.namespace === '' || (!isMobile && this.data.current.namespace === 'shop-wall')){
                new SwiperProductFeed(document.querySelector('.swiper-slider-feed'))
                headerClass.apriHeaderFeedVino()
            }
        }
        else{
            // console.log('non data')
        }
        // this.clickCloseMinicart()
        if(this.container.querySelector('.product-features') !== null){
            if(!isAllMobileDevices){
                this.revealFeaturesIconsOnScroll()
            }
        }
        this.selectQty()
        this.clickAddToCartBtn()
        if(this.popupAcquista.querySelector('.confezioni') !== null){            
            this.clickAddConfezioneToCartBtn()
        }

        if(this.productType === 'variable'){
            this.selectSize()
        }
        if(this.openPopupAcquistaBtn !== null){
            this.openPopupAcquistaBtn.addEventListener('click', () => {
                this.openPopupAcquista()
            })
        }
        this.closePopupAcquistaBtn.addEventListener('click', () => {
            this.closePopupAcquista()
        })
        
        if(this.container.querySelector('.aside-zoom') !== null){
            this.zoomBtn.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                if(this.isZoomEnabled){
                    this.zoomOut()
                }
                else{
                    this.zoomIn()
                }
            })
        }
        if(this.container.querySelector('.aside-zoom') !== null){
            //Moove bottle up/down on mousemove
            this.asideZoom.addEventListener('mousemove', e => {
                if(!this.isZoomEnabled) return
                this.coeff = -2 * (e.clientY / winsize.height - 0.5)
                this.moveY = (this.asideImageDimensionsHeight - winsize.height) / 1.8
                gsap.to(this.asideImage,{
                    duration: 0.4,
                    y: this.moveY*this.coeff
                })
            })
        }

        if(this.popupAcquista.querySelector('.container-confezioni') !== null){
            this.btnOpenContainerConfezioni.addEventListener('click', () => {
                this.openContainerConfezioni()
            })
            this.btnCloseContainerConfezioni.addEventListener('click', () => {
                this.closeContainerConfezioni()
            })
            this.setContainerConfezioniDimensions()  
            window.addEventListener('resize', () => {
                this.setContainerConfezioniDimensions()  
            })    
            this.rowsConfezioniDesktop.forEach( rowConfezione => {
                new QuantitySelectorConfezioni(rowConfezione)
                rowConfezione.addEventListener('mouseover', () => {
                    if(!this.isHoverConfezioniEnabled) return
                    let dataConfezione = rowConfezione.getAttribute('data-confezione')
                    let slide = this.containerConfezioni.querySelector(`.confezioni__hover-slider .slide[data-confezione="${dataConfezione}"]`)
                    // console.log(dataConfezione)
                    // TweenMax.to(this.bgSiparioSpan, 0.4,{
                    //     autoAlpha: 1
                    // })
                    TweenMax.to(slide,0.6,{
                        // duration: 0.6,
                        autoAlpha: 1,
                        ease: 'power1.in'
                    })
                    TweenMax.to(slide,0.6,{
                        // duration: 0.6,
                        y: 0,
                        ease: 'power2.out'
                    })
                })
                rowConfezione.addEventListener('mouseleave', () => {
                    let dataConfezione = rowConfezione.getAttribute('data-confezione')
                    let slide = this.containerConfezioni.querySelector(`.confezioni__hover-slider .slide[data-confezione="${dataConfezione}"]`)
                    // TweenMax.to(this.bgSiparioSpan, 0.4,{
                    //     autoAlpha: 0.95
                    // })                    
                    TweenMax.to(slide,0.6,{
                        // duration: 0.4,
                        autoAlpha: 0,
                        y: 80
                    })
                })
            })
            this.rowsConfezioniMobile.forEach( rowConfezioneMobile => {
                new QuantitySelectorConfezioni(rowConfezioneMobile)
                new RowConfezioneMobile(rowConfezioneMobile)
            })
            if(this.containerConfezioni.querySelector('.select-colori') !== null){
                this.selectsColoreConfezioni.forEach( selectColore => { 
                    let selectHeader = selectColore.querySelector('.select-colori__header')
                    selectHeader.addEventListener('click', () => {
                        if(selectColore.classList.contains('open')){
                            this.closeSelectColori(selectColore)
                        }
                        //open select
                        else{
                            //Chiudo le altre select aperte
                            this.closeAllSelects(selectColore)
                            this.openSelectColori(selectColore)
                        }
                    })             
                    this.selezionaColore(selectColore)
                })
            }     
        }

        if(this.productType === 'booking'){
            this.initBookingProduct()
        }


    }

    
    selezionaColore(selectColore){
        let colori = selectColore.querySelectorAll('.colore')
        colori.forEach( colore => {
            colore.addEventListener('click', () => {
                let dataColorId = colore.getAttribute('data-color-id')
                let dataColorName = colore.getAttribute('data-color-name')
                // console.log(dataColorName)
                let btnAddToCart = selectColore.closest('.row').querySelector('.btn-add-confezione-to-cart')
                
                // let dataColorPrice = colore.getAttribute('data-color-price')
                // selectColore.setAttribute('data-colore-selezionato-id', dataColorId)
                btnAddToCart.setAttribute('data-color-id', dataColorId)
                // btnAddToCart.setAttribute('data-color-price', dataColorPrice)
                this.closeSelectColori(selectColore)
                gsap.to(selectColore.querySelector('.js-selected-color'),{
                    duration: 0.3,
                    autoAlpha:0,  
                    onComplete: () => {
                        selectColore.querySelector('.js-selected-color').innerHTML = dataColorName            
                        gsap.to(selectColore.querySelector('.js-selected-color'),{
                            duration: 0.3,
                            autoAlpha:1,                    
                        })
                    }                  
                })
            })
        })
    }
    closeSelectColori(selectColore){
        let selectColoriLista = selectColore.querySelector('.select-colori__lista')
        gsap.to(selectColoriLista, {
            duration: 0.4,
            height:0,
        })
        selectColore.classList.remove('open')
    }
    openSelectColori(selectColore){
        let rowConfezione = selectColore.closest('.row')
        let selectColoriLista = selectColore.querySelector('.select-colori__lista')
        let height = selectColore.querySelector('.lista__wrapper').getBoundingClientRect().height
        rowConfezione.style.zIndex = 2
        // if(rowConfezione.querySelector('.row-confezione-mobile__body') !== null){
        //     rowConfezione.querySelector('.row-confezione-mobile__body').style.overflow = 'visible'
        // }
        gsap.to(selectColoriLista, {
            duration: 0.6,
            height,
            ease: 'power1.out'
        })
        selectColore.classList.add('open')
    }
    closeAllSelects(selectSelezionata){
        this.selectsColoreConfezioni.forEach( s => {
            if(!s.isSameNode(selectSelezionata)){
                let row = s.closest('.row')
                let listaDaChiudere = s.querySelector('.select-colori__lista')                                    
                row.style.zIndex = 1
                s.classList.remove('open')
                gsap.to(listaDaChiudere, {
                    duration: 0.4,
                    height:0,
                    onComplete: () => {
                        // if(row.querySelector('.row-confezione-mobile__body') !== null){
                        //     row.querySelector('.row-confezione-mobile__body').style.overflow = 'hidden'
                        // }                        
                    }
                })
            }
        })    
    }

    initBookingProduct(){       
        this.disponibilita = 0
        // this.orarioSelezionato = this.pageProduct.querySelector('.orario-selezionato').innerHTML
        // this.addToCartBtn.setAttribute('data-orario-selezionato', this.orarioSelezionato)  
        this.warningPostiDisponibili = this.pageProduct.querySelector('.warning-posti-disponibili')
        this.datePickerContainer = this.pageProduct.querySelector('.datepicker-container')
        this.alertNoBookingDateSelectedTxt = this.pageProduct.querySelector('.seleziona-una-data')
        /**
         * YITH DATEPICKER
         */  
        // this.inputDatepicker = this.pageProduct.querySelector('.buy-actions__datepicker #yith-wcbk-booking-start-date-770')
        // this.inputDatepickerValue = this.inputDatepicker.value
        //Osservo il valore dell'input del data picker, così è sempre aggiornato
        // setInterval( () => {
        //     //Detect value changed
        //     if(this.inputDatepicker.value !== this.inputDatepickerValue){
        //         this.addToCartBtn.setAttribute('data-start-date', this.inputDatepicker.value)
        //         this.updateBookingValuesAjax('change_start_date', this.inputDatepicker.value, this.orarioSelezionato)
        //     }
        //     // Aggiorno la data
        //     this.inputDatepickerValue = this.inputDatepicker.value
        // }, 100)

        /**
         * AIR DATEPICKER
         */
        this.inputDatepicker = this.pageProduct.querySelector('.buy-actions__datepicker .datepicker-container input')
        this.inputDatepickerValue = this.inputDatepicker.value
        let locale = language === 'it' ? localeIt : localeEn
        let customDatepicker = this.container.querySelector('.custom-datepicker')
        let dateNonDisponibili = customDatepicker.getAttribute('data-non-disponibili')
        let airDatepicker = new AirDatepicker(customDatepicker, {
            locale,
            // inline: true,
            minDate: new Date(),
            maxDate: new Date().setMonth(new Date().getMonth() + 11),
            isMobile: this.isTouchDevice,
            autoClose: true,
            onRenderCell: ({date, cellType}) => {
                // var dataFormattata = date.getFullYear() + "-" + ("00" + (date.getMonth() + 1)).slice(-2) + "-" + ("00" + date.getDate()).slice(-2)
                let fullYear = date.getFullYear()
                let month = ("00" + (date.getMonth() + 1)).slice(-2)
                let day = ("00" + date.getDate()).slice(-2)
                let dataFormattata = `${fullYear}-${month}-${day}`
                //Disabilito tutte le date non disponibili
                if (cellType === 'day') {
                    if(dateNonDisponibili.includes(dataFormattata)){
                        return {
                            disabled: true,
                            classes: 'disabled-class',
                            attrs: {
                                title: 'Cell is disabled'
                            }
                        }
                    }
                }
            },
            onSelect: ({date}) => {
                // console.log(date)
                if(!date) return
                let fullYear = date.getFullYear()
                let month = ("00" + (date.getMonth() + 1)).slice(-2)
                let day = ("00" + date.getDate()).slice(-2)
                let startDate = `${fullYear}-${month}-${day}` //2023-02-27
                // this.addToCartBtn.setAttribute('data-start-date', startDate)
                // let startHour = this.orarioSelezionato
                // this.updateBookingValuesAjax('change_start_date', startDate, startHour) 
                this.resetInputQty()
                this.updateBookingValuesAjax('change_start_date', startDate)  
                this.inputDatepickerValue = this.inputDatepicker.value
            }
        })
    }

    updateBookingValuesAjax(action, startDate){
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/booking.php'
        let productId = this.addToCartBtn.getAttribute('data-product-id')
        formData.append('action', action)
        formData.append('productId', productId)
        formData.append('startDate', startDate)
        // formData.append('startHour', startHour)
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let resultObj = JSON.parse(request.response)
                let timeSlotsQuantity = resultObj.timeSlotsQuantity
                let postiDisponibili = resultObj.postiDisponibili
                this.disponibilita = postiDisponibili[0]
                let froms = resultObj.froms
                let startHours = resultObj.startHours

                //Popolo l'add to cart button
                this.updateAddToCartButton(froms[0], postiDisponibili[0], startHours[0], startDate)                

                //Popolo lista orari possibili
                let listaOrari = ''
                    startHours.forEach((startHour, i) => {
                        listaOrari += `<div class="orario ${i == 0 ? 'active' : ''}" data-orario="${startHour}" data-from="${froms[i]}" data-posti-disponibili="${postiDisponibili[i]}">`
                            listaOrari += '<div class="orario__radio-button">'
                                listaOrari += '<div class="radio-button__border">'
                                listaOrari += '</div>'
                                listaOrari += '<div class="radio-button__checked">'
                                listaOrari += '</div>'
                            listaOrari += '</div>'
                            listaOrari += `<div class="orario__ora"><span>${startHour}</span></div>`
                        listaOrari += '</div>'
                    })
                // listaOrari += '</div>'
                if(document.querySelector('.lista-orari') !== null){
                    document.querySelector('.lista-orari').innerHTML = listaOrari
                }                
                this.container.querySelectorAll('.orario').forEach(timeSlot => {
                    timeSlot.addEventListener('click', () => {
                        if(timeSlot.classList.contains('active')) return
                        let f = timeSlot.getAttribute('data-from')
                        let pd = timeSlot.getAttribute('data-posti-disponibili')
                        this.disponibilita = pd
                        let sh = timeSlot.getAttribute('data-orario')      

                        this.container.querySelectorAll('.orario').forEach(o => {
                            o.classList.remove('active')
                        })
                        timeSlot.classList.add('active') 
                        this.resetInputQty()                        
                        //Popolo l'add to cart button
                        this.updateAddToCartButton(f, pd, sh) 
                    })
                })

                //Imposto il messaggio di avviso posti disponibili
                let textPostiDisponibili = language === 'it' ? `Ci sono ancora ${postiDisponibili[0]} posti disponibili` : `There are ${postiDisponibili[0]} places available`
                if(postiDisponibili[0] === 0){
                    //Mostra avviso posti disponibili
                    this.warningPostiDisponibili.classList.remove('hidden')
                    textPostiDisponibili = language === 'it' ? `Per questa data non ci sono più posti disponibili` : `There are no more places available for this date`
                }
                else{
                    this.popupAcquista.querySelector('.buy-actions__qty').classList.remove('is-waiting')
                    this.addToCartBtn.classList.remove('is-waiting')
                    if(postiDisponibili[0] < 10){       
                        //Mostra avviso posti disponibili         
                        this.warningPostiDisponibili.classList.remove('hidden')
                        if(postiDisponibili[0] === 1){
                            textPostiDisponibili = language === 'it' ? `C'è ancora ${postiDisponibili[0]} posto disponibile` : `There is ${postiDisponibili[0]} place available`
                        }
                        this.pageProduct.querySelector('.js-posti-disponibili').innerHTML = textPostiDisponibili
                    }
                    else{
                        //Nascondi messaggio
                        this.warningPostiDisponibili.classList.add('hidden')
                        this.pageProduct.querySelector('.js-posti-disponibili').innerHTML = textPostiDisponibili
                    }
                }
            }
        }
        request.send(formData)
    }

    updateAddToCartButton(from, postiDisponibili, orarioSelezionato, startDate = null){
        //La data cambia solo se si cambia sul data picker, invece from, postiDisponibili e orarioSelezionato cambiano anche al cambio dell'orario
        if(startDate) this.addToCartBtn.setAttribute('data-start-date', startDate)  
        this.addToCartBtn.setAttribute('data-from', from)
        this.addToCartBtn.setAttribute('data-posti-disponibili',postiDisponibili)
        this.addToCartBtn.setAttribute('data-orario-selezionato', orarioSelezionato)       
    }

    initAnimations(){
        gsap.to(this.container.querySelector('.product-title__wrapper'),{
            duration: 0.9,
            y:0
        })
        gsap.to(this.container.querySelector('.product-bg'),{
            duration: 0.9,
            y:0,
            delay:0.4,
            ease: 'power2.out'
        })
        gsap.to(this.container.querySelector('.product-bg'),{
            duration: 0.9,
            opacity:1,
            delay:0.4,
            ease: 'power1.in'
        })         
    }


    clickAddToCartBtn(){
        this.addToCartBtn.addEventListener('click', () => {
            if (this.isAnimating) return
            this.isAnimating = true
            if(this.addToCartBtn.classList.contains('.is-waiting')) return
            if(this.isZoomEnabled){
                this.zoomOut()
            }
            let from = null
            if(this.productType === 'booking'){
                if(this.inputDatepickerValue === '') {
                    //inserire un alert Scegli Data
                    this.alertNoBookingDateSelected()
                    this.isAnimating = false
                    return
                }
                if(this.disponibilita === 0){                    
                    this.isAnimating = false
                    return
                }
                from = this.from = this.addToCartBtn.getAttribute('data-from')
            }

            let sizeId = this.addToCartBtn.getAttribute('data-size-id')
            let productId = this.addToCartBtn.getAttribute('data-product-id')
            let qty = Number(this.addToCartBtn.getAttribute('data-product-qty'))
            minicart.beforeOpen()
            addToCart(productId, sizeId, qty, from).then(() => {
                this.movePopupAcquista('left')   
                minicart.open().then( () => {
                    customDatalayerClass.ajaxCall('add__to_cart', {product_id:productId, size_id: sizeId, product_type: this.productType}).then(res => {
                        // console.log(res)
                        customDatalayerClass.addToCartDataLayer(res)
                    })
                    this.isAnimating = false
                })     
             
            })
        })        
    }

	alertNoBookingDateSelected(){
		gsap.to(this.alertNoBookingDateSelectedTxt,{
			duration:0.2,
			color: '#f00',
			onComplete: () => {
				gsap.timeline({repeat:2})
					//body overflow hidden
					.to(this.datePickerContainer ,{
						duration:0.05,
						x:20
					})
					.to(this.datePickerContainer ,{
						duration:0.05,
						x:0
					})
                
                gsap.to(this.alertNoBookingDateSelectedTxt,{
                    duration:0.2,
                    color: '#000',
                    delay: 0.6
                })
			}
		})
	}    

    clickAddConfezioneToCartBtn(){
        this.bottoniAggiungiConfezione.forEach( btnAggiungiConfezione => {
            btnAggiungiConfezione.addEventListener('click', () => {
                // console.log('quiiii')
                if (this.isAnimating) return
                this.isAnimating = true
   
                let colorId = btnAggiungiConfezione.getAttribute('data-color-id')
                let confezioneId = btnAggiungiConfezione.getAttribute('data-product-id')
                let qty = Number(btnAggiungiConfezione.getAttribute('data-product-qty'))
                // console.log(confezioneId, colorId, qty)
                minicart.beforeOpen()
                addToCart(confezioneId, colorId, qty).then(() => {
                    this.aggiungiUnVinoSeNonPresenteNelCarrello()
                    this.movePopupAcquista('left')   
                    minicart.open().then( () => {
                        this.isAnimating = false
                    })     
                })
            })    
        })
    }


    aggiungiUnVinoSeNonPresenteNelCarrello(){
        let vinoId = this.addToCartBtn.getAttribute('data-product-id')
        let formatoId = this.addToCartBtn.getAttribute('data-size-id')
        if(minicart.minicartContainer.querySelector(`.minicart__item[data-product-category="vino"]`) === null){
            addToCart(vinoId, formatoId, 1)
        }
        else{

        }
    }

    movePopupAcquista(direction){
        let x = direction === 'left' ? '-35%' : '0%'
        gsap.to(this.popupAcquistaInner,{
            duration: 1.2,
            x: x,
            ease: 'power2.inOut',
        })   
    }
    moveContainerConfezioni(direction){
        // let x = direction === 'left' ? '-35%' : '0%'
        // gsap.to(this.popupAcquistaInner,{
        //     duration: 1.2,
        //     x: x,
        //     ease: 'power2.inOut',
        // })   
    }

    selectSize(){
        this.sizes.forEach(size => {
            let sizeId = size.getAttribute('data-size-id')
            let regPrice = size.getAttribute('data-size-reg-price')
            let salePrice = size.getAttribute('data-size-sale-price')
            let price = size.getAttribute('data-size-price')
            // console.log(typeof(salePrice))
            size.addEventListener('click', () => {
                if (size.classList.contains('selected')) return
                if (size.classList.contains('non-disponibile')) return
                if(this.isAnimating) return
                this.isAnimating = true
                this.resetInputQty()
                this.updatePrice(price, regPrice, salePrice)
                // this.isSizeSelected = true
                // gsap.to(this.alertSizeTxt, {
                //     duration: 0.4,
                //     autoAlpha: 0
                // })
                if(size.getAttribute('data-size-disponibilita')){
                    this.disponibilita = size.getAttribute('data-size-disponibilita')
                }
                this.sizes.forEach(taglia => {
                    taglia.classList.remove('selected')
                })
                size.classList.add('selected')
                this.addToCartBtn.setAttribute('data-size-id', sizeId)
                this.addToCartBtn.setAttribute('data-size-price', price)
                // this.ctaAddToCart.classList.remove('disabled')
            })
        })
    }

    updatePrice(price, regPrice, salePrice){
        this.hiddenPriceSpan.innerHTML = price
        if(salePrice !== ''){
            this.hiddenPriceSpanBarrato.innerHTML = regPrice
        }
        gsap.to(this.visiblePrice,{
            duration: 0.8,
            y: '-100%',
            ease: 'power2.out'

        })
        gsap.to(this.hiddenPrice,{
            duration: 0.8,
            y: '-100%',
            ease: 'power1.out',
            onComplete: () => {
                this.visiblePriceSpan.innerHTML = price
                if(salePrice !== ''){
                    this.visiblePriceSpanBarrato.innerHTML = regPrice
                }
                gsap.set(this.visiblePrice,{
                    y: '0%'
                })
                gsap.set(this.hiddenPrice,{
                    y: '0%'
                })
                this.isAnimating = false
            }
        })
    }

    toggleQtyBtns(){
        if(this.inputQty.value <= 1){
            this.removeQtyBtn.classList.add('disabled')
        }
        else{
            this.removeQtyBtn.classList.remove('disabled')
        }
        if(this.inputQty.value >= this.disponibilita){
            this.addQtyBtn.classList.add('disabled')
        }
        else{
            this.addQtyBtn.classList.remove('disabled')
        }
    }

    selectQty(){
        this.addQtyBtn.addEventListener('click', () => {
            if(this.quantitaSelezionata >= this.disponibilita) return             
            if(this.popupAcquista.querySelector('.buy-actions__qty').classList.contains('is-waiting')) return
            this.quantitaSelezionata++
            this.inputQty.value = this.quantitaSelezionata
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.removeQtyBtn.addEventListener('click', () => {
            if(this.quantitaSelezionata < 2) return
            if(this.popupAcquista.querySelector('.buy-actions__qty').classList.contains('is-waiting')) return
            this.quantitaSelezionata--
            this.inputQty.value = this.quantitaSelezionata
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.inputQty.addEventListener('keyup', () => {
            // console.log(this.disponibilita, this.inputQty.value)
            // console.log(this.inputQty.value < this.disponibilita)
            // console.log(Number(this.inputQty.value) < Number(this.disponibilita))
            this.inputQty.value = gsap.utils.clamp(1,Number(this.disponibilita),Number(this.inputQty.value))
            // console.log(gsap.utils.clamp(1,this.disponibilita,this.inputQty.value))
            let field = this.inputQty.value
            this.inputQty.value = validDigits(field)
            // console.log(this.inputQty.value)
            this.quantitaSelezionata = this.inputQty.value
            // console.log(this.disponibilita)
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.inputQty.addEventListener('blur', () => {
            let field = this.inputQty.value
            if (field == '') {
                this.inputQty.value = 1
            }
            this.quantitaSelezionata = this.inputQty.value
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
        })
    }

    revealFeaturesIconsOnScroll(){
        // console.log('aho')
        this.awdScroll.on("scroll", () => {
            const triggerDimensions = this.triggerFeaturesIcons.getBoundingClientRect()
            const triggerOffsetTop = triggerDimensions.top - winsize.height
            if(triggerOffsetTop < 0 && triggerOffsetTop + triggerDimensions.height > 0){
                let opacity = Math.abs(triggerOffsetTop/(triggerDimensions.height*0.5))
                let filterBlur = (1 - Math.abs(triggerOffsetTop/triggerDimensions.height))*40
                if(opacity < 0.2){
                    opacity  = 0
                    // filterBlur = 40
                }
                else if(opacity > 0.8){
                    opacity = 1
                    // filterBlur = 0
                }
                gsap.to(this.productFeaturesLeft,{
                    duration: 0.2,
                    opacity: opacity,
                    // filter: `blur(${filterBlur}px)`
                })
                gsap.to(this.productFeaturesRight,{
                    duration: 0.2,
                    opacity: opacity,
                    // filter: `blur(${filterBlur}px)`
                })
            }
        })
    }

    zoomIn(){
        this.zoomBtn.classList.add('active')
        gsap.to(this.zoomBtnIcon,{
            duration: 0.8,
            rotation: 45
        })
        gsap.to(this.imageScaled, {
            duration: 0.8,
            scale: 1,
            onComplete:() => {
                this.isZoomEnabled = true
                this.isAnimating = false
            }
        })
    }
    zoomOut(){
        this.zoomBtn.classList.remove('active')
        this.isZoomEnabled = false
        gsap.to(this.zoomBtnIcon,{
            duration: 0.8,
            rotation: 0
        })
        gsap.to(this.asideImage,{
            duration: 0.4,
            y: 0
        })
        gsap.to(this.imageScaled, {
            duration: 0.8,
            scale: 0.25,
            onComplete:() => {
                this.isAnimating = false
            }
        })
    }

    openPopupAcquista(){
        this.awdScroll.stop()
        this.header.classList.remove('active')
        this.header.classList.add('header-bloccato')
        this.popupAcquista.classList.add('opened')
        // this.openPopupAcquistaBtn.querySelector('.button--border').classList.add('active')
        let zIndex = 19
        if(isAllMobileDevices){
            zIndex = 3900
            document.querySelector('body').style.overflow = 'hidden'
        }
        gsap.set(this.popupAcquista,{
            'pointer-events': 'auto',
            'z-index': zIndex
        })
        gsap.set(this.popupAcquistaContainer,{
            y: '0%'
        })
        gsap.to(this.popupAcquistaBg, {
            duration: 1.2,
            width: '100%',
            ease: 'power2.inOut'
        })
        gsap.to(this.popupAsideBuyActionsBg,{
            duration: 1.2,
            delay: 0.4,
            width: '100%',
            ease: 'power2.inOut'
        })
        riseAndFadeIn(this.closePopupAcquistaBtn,{delay: 0.8})
        if(this.asideImageInner){
            riseAndFadeIn(this.asideImageInner,{delay: 0.8})
        }
        if(this.zoomBtn){
            riseAndFadeIn(this.zoomBtn, {delay: 1})
        }
        riseAndFadeIn(this.popupAsideBuyActionsWrapper, {delay: 1.2})
    }

    closePopupAcquista(){
        if(this.isZoomEnabled){
            this.zoomOut()
        }
        if(this.containerConfezioni){
            this.closeContainerConfezioni()
        }
        riseAndFadeOut(this.closePopupAcquistaBtn,{destination: 0})
        if(this.asideImageInner){
            riseAndFadeOut(this.asideImageInner, {destination: 80})
        }
        if(this.zoomBtn){
            riseAndFadeOut(this.zoomBtn)
        }
        riseAndFadeOut(this.popupAsideBuyActionsWrapper)
        gsap.to(this.popupAsideBuyActionsBg,{
            duration: 0.6,
            delay: 0.4,
            width: '0%',
            ease: 'power2.inOut'
        })
        gsap.to(this.popupAcquistaBg, {
            duration: 0.8,
            delay: 0.45,
            width: '0%',
            ease: 'power2.inOut',
            onComplete: () => {
                this.resetPopupAcquista()
                this.resetDefaltValues()
                // this.openPopupAcquistaBtn.querySelector('.button--border').classList.remove('active')
                if(isAllMobileDevices){
                    document.querySelector('body').style.overflow = 'visible'
                }
            }
        })
    }

    resetPopupAcquista(){
        this.awdScroll.start()
        this.header.classList.add('active')
        this.header.classList.remove('header-bloccato')
        this.popupAcquista.classList.remove('opened')
        gsap.set(this.popupAcquista,{
            'pointer-events': 'none',
            'z-index': -1
        })
        gsap.set(this.popupAcquistaContainer,{
            y: '-100%'
        })
    }
    /**
     * CONFEZIONI
     */
    //Cosi il contenuto è sempre visibile
    setContainerConfezioniDimensions(){
        if(winsize.height < this.wrapperConfezioni.getBoundingClientRect().height){
            this.bgConfezioni.style.height = '100%'
            this.containerConfezioniInner.style.overflowY = 'scroll'
        }
        else{
            this.bgConfezioni.style.height = '100vh'
            this.containerConfezioniInner.style.overflowY = 'hidden'
        }
    }
    openContainerConfezioni(){
        gsap.set(this.containerConfezioni,{
            y: '0%'
        })
        gsap.to(this.bgSiparioSpan, {
            duration: 0.8,
            width: '100%',
            ease: 'power1.inOut'
        })
        gsap.to(this.bgConfezioniSpan, {
            duration: 0.8,
            width: '100%',
            delay: 0.4,
            ease: 'power1.inOut',
            onComplete: () => {
                this.isHoverConfezioniEnabled = true
            }
        })
        if(this.wrapperConfezioni){
            riseAndFadeIn(this.wrapperConfezioni, {delay: 0.8})
        }
        if(this.btnCloseContainerConfezioni){
            riseAndFadeIn(this.btnCloseContainerConfezioni, {delay: 0.8})
        }
    }
    closeContainerConfezioni(){
        if(this.wrapperConfezioni){
            riseAndFadeOut(this.wrapperConfezioni)
        }
        if(this.btnCloseContainerConfezioni){
            riseAndFadeOut(this.btnCloseContainerConfezioni, {destination: 0})
        }

        this.isHoverConfezioniEnabled = false
        gsap.to(this.bgConfezioniSpan, {
            duration: 0.5,
            width: '0%',
            delay: 0.45,
            ease: 'power1.inOut'
        })
        gsap.to(this.bgSiparioSpan, {
            duration: 0.5,
            width: '0%',
            delay: 0.5,
            ease: 'power1.inOut'
        })
        gsap.set(this.containerConfezioni,{
            y: '-100%',
            delay: 0.9
        })
    }
    /**
     * 
     */


    resetDefaltValues(){
        this.resetInputQty()
        if(this.productType === 'variable'){
            this.sizes.forEach(taglia => {
                taglia.classList.remove('selected')
            })
            this.sizes[0].classList.add('selected')
            let sizeId = this.sizes[0].getAttribute('data-size-id')
            let sizePrice = this.sizes[0].getAttribute('data-size-price')
            this.addToCartBtn.setAttribute('data-size-id', sizeId)
            this.addToCartBtn.setAttribute('data-size-price', sizePrice)
        }
        else{
            this.addToCartBtn.setAttribute('data-size-id', 0)
        }
    }

    resetInputQty(){
        this.quantitaSelezionata = 1
        this.inputQty.value = 1
        this.addToCartBtn.setAttribute('data-product-qty', 1)
    }
}

class QuantitySelectorConfezioni{
    constructor(rowConfezione){
        this.rowConfezione = rowConfezione
        this.quantitySlector = this.rowConfezione.querySelector('.col--qty')
        this.inputQty = this.quantitySlector.querySelector('.input-qty')
        this.addQtyBtn = this.quantitySlector.querySelector('.qty__action--add')
        this.removeQtyBtn = this.quantitySlector.querySelector('.qty__action--remove')
        this.addToCartBtn = this.rowConfezione.querySelector('.btn-add-confezione-to-cart')
        this.disponibilitaConfezioni
        this.quantitaSelezionata = 1
        this.selectQty()

    }
    toggleQtyBtns(){
        if(this.inputQty.value <= 1){
            this.removeQtyBtn.classList.add('disabled')
        }
        else{
            this.removeQtyBtn.classList.remove('disabled')
        }
        if(this.inputQty.value >= this.disponibilitaConfezioni){
            this.addQtyBtn.classList.add('disabled')
        }
        else{
            this.addQtyBtn.classList.remove('disabled')
        }
    }

    selectQty(){
        this.addQtyBtn.addEventListener('click', () => {
            if(this.quantitaSelezionata >= this.disponibilitaConfezioni){
                return
            }
            this.quantitaSelezionata++
            this.inputQty.value = this.quantitaSelezionata
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.removeQtyBtn.addEventListener('click', () => {
            if(this.quantitaSelezionata < 2){
                return
            }
            this.quantitaSelezionata--
            this.inputQty.value = this.quantitaSelezionata
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.inputQty.addEventListener('keyup', () => {
            this.inputQty.value = gsap.utils.clamp(1,this.disponibilitaConfezioni,this.inputQty.value)
            let field = this.inputQty.value
            this.inputQty.value = validDigits(field)
            this.quantitaSelezionata = this.inputQty.value
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
            this.toggleQtyBtns()
        })
        this.inputQty.addEventListener('blur', () => {
            let field = this.inputQty.value
            if (field == '') {
                this.inputQty.value = 1
            }
            this.quantitaSelezionata = this.inputQty.value
            this.addToCartBtn.setAttribute('data-product-qty',this.quantitaSelezionata)
        })
    }    
}


class RowConfezioneMobile{
    constructor(row){
        this.row = row
        this.rowHeader = this.row.querySelector('.row-confezione-mobile__header')

        this.rowBody = this.row.querySelector('.row-confezione-mobile__body')
        this.rowHeight = this.row.querySelector('.row-confezione-mobile__content').getBoundingClientRect().height

        if(this.row.querySelector('.select-colori') !== null){
            this.selectColori = this.row.querySelector('.select-colori')
            this.selectColoriLista = this.row.querySelector('.select-colori__lista')            
        }

        this.plus = this.row.querySelector('.plus')
        this.plusSvg = this.row.querySelector('.svg-plus')

        this.rows = [...document.querySelectorAll('.row-confezione-mobile')]
        
        this.isAnimating = false

        this.initEvents()

    }


    initEvents(){
        this.rowHeader.addEventListener('click', () => {
            if (this.isAnimating) return
            this.isAnimating = true
            this.calculateHeight()
            if (this.row.classList.contains('open')) {
                this.close()
            }
            else {
                this.open()
                this.closeOthers()
            }
        })
    }

    calculateHeight(){
        this.rowHeight = this.row.querySelector('.row-confezione-mobile__content').getBoundingClientRect().height
    }

    open(){
        this.row.classList.add('current')
        gsap.to(this.rowBody,{
            duration: 0.4,
            height: this.rowHeight,
            ease: 'power2.inOut'
        })
        gsap.to(this.plus, {
            duration: 0.4,
            rotation: 45,
            ease: 'power1.inOut',
            onComplete: () => {
                this.rowBody.style.overflow = 'visible'
                this.row.classList.remove('current')
                this.isAnimating = false
            }
        })
        this.row.classList.add('open')
    }

    close(){
        if (this.row.classList.contains('open')) {
            // this.clean()
            this.rowBody.style.overflow = 'hidden'
            gsap.to(this.rowBody, {
                duration: 0.3,
                height: 0
            });

            gsap.to(this.plus, {
                duration: 0.4,
                rotation: 0,
                ease: 'power1.inOut',
                onComplete: () => {
                    this.isAnimating = false
                }
            })
            this.row.classList.remove('open')
            if(this.selectColori !== null){
                this.closeSelectColori(this.selectColori)
            }         
        }        
    }

    closeOthers(){
        this.rows.forEach( row => {
            if (!row.classList.contains('current')) {
                let rowBody = row.querySelector('.row-confezione-mobile__body')
                // let rowBg = row.querySelector('.bg-row')
                // let titolo = row.querySelector('.titolo')
                let plus = row.querySelector('.plus')
                // gsap.to(titolo, {
                //     duration: 0.3,
                //     color: this.colorBlack
                // })

                // gsap.to(rowBg, {
                //     duration: 0.15,
                //     height: '0%',
                //     ease: 'power1.inOut'
                // })

                rowBody.style.overflow = 'hidden'
                gsap.to(plus, {
                    duration: 0.3,
                    rotation: 0,
                    ease: 'power1.inOut'
                })
                gsap.to(rowBody, {
                    duration: 0.3,
                    height: 0,
                    // onComplete: () => {
                    //     rowBody.style.overflow = 'hidden'
                    // }
                });
                row.classList.remove('open')

                if(row.querySelector('.select-colori') !== null){
                    this.closeSelectColori(row.querySelector('.select-colori'))
                }                         
                
            }
        })
    }

    closeSelectColori(selectColore){
        let selectColoriLista = selectColore.querySelector('.select-colori__lista')
        gsap.to(selectColoriLista, {
            duration: 0.4,
            height:0,
        })
        selectColore.classList.remove('open')
    }    
}

export {Product}
